const initialState = {
	cartArray: [],
	cartQuantity: 0,
	listArray: [],
	currentPrebasketProduct: {},
	prebasketUpdated: false,
};

const shoppingReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_CART_ARRAY':
			return {
				...state,
				cartArray: action.cartArray,
				cartQuantity: action.cartQuantity,
			};
		case 'SET_LIST_ARRAY':
			return {
				...state,
				listArray: action.listArray,
			};
		case 'SET_CURRENT_PREBASKET_PRODUCT':
			return {
				...state,
				currentPrebasketProduct: action.currentPrebasketProduct,
			};
		case 'SET_PRE_BASKET_UPDATED':
			return {
				...state,
				prebasketUpdated: action.prebasketUpdated,
			};
		default:
			return state;
	}
};

export default shoppingReducer;
